import React, {useEffect, useState} from "react";
import QnectTextField from "../qnect-ui/qnect-text-field";
import QnectDateField from "../qnect-ui/qnect-date-field";
import QnectSelectField from "../qnect-ui/qnect-select-field";
import FieldWrapper from "../custom/field-wrapper";
import QnectButton from "../qnect-ui/qnect-button";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "../custom/dialog-title";
import DialogSecondaryTitle from "../custom/dialog-secondary-title";
import Dialog from '../custom/dialog';
import {useDialogStyles} from "../custom/dialog-style";
import useConfig from "../qnect-ui/qnect-config";
import {_generateUuid, _validateForm, _validateNric, isParentMember} from "../../utils/utility";
import moment from "moment";
import {DialogContentText} from "@material-ui/core";

export const AddUserDialog = ({open = false, onClose, onOk, parentOptions, props}) => {
    const classes = useDialogStyles();
    const cfg = useConfig();
    const formId = 'addUserForm';

    const [heading, setHeading] = useState('Policy Number: ' + props.policy?.policyNumber);
    const [name, setName] = useState(null);
    const [employmentDate, setEmploymentDate] = useState(null);
    const [effectiveDate, setEffectiveDate] = useState(null);
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [securityId, setSecurityId] = useState(null);
    const [relationship, setRelationship] = useState(null);
    const [parentMember, setParentMember] = useState(null);
    const [nricErrorMessage, setNricErrorMessage] = useState('');
    const [effectiveDateErrorMessage, setEffectiveDateErrorMessage] = useState('');
    const [employmentDateErrorMessage, setEmploymentDateErrorMessage] = useState('');
    const [relationshipErrorMessage, setRelationshipErrorMessage] = useState('');
    const [subsidiaryNo, setSubsidiaryNo] = useState(props.policy?.subsidiaryNo);
    const [planId, setPlanId] = useState(props.policy?.planId);
    const [emailAddress, setEmailAddress] = useState(null);
    const [gender, setGender] = useState(null);
    const currentDate = moment(new Date(), 'DD/MM/YYYY');
    const [allowAdd, setAllowAdd] = useState(true);

    const onClickOk = () => {
        if (_validateForm(formId)) {
            setNricErrorMessage('');
            setEffectiveDateErrorMessage('');
            setEmploymentDateErrorMessage('');
            if (!_validateNric(securityId)) {
                setNricErrorMessage(cfg('errorMessage.invalidNric'));
                return;
            }

            if (!validateDates()){
                return;
            }

            // if member is not parent, cannot change plan/subsidiary
            if (relationship !== '00') {
                if (props.policy?.subsidiaryNo !== subsidiaryNo || props.policy?.planId !== planId) {
                    setRelationshipErrorMessage('errorMessage.cannotChangePlan');
                    return;
                }
            }

            let obj = {
                name: name,
                employmentDate: employmentDate,
                effectiveDate: effectiveDate,
                dateOfBirth: dateOfBirth,
                securityId: securityId,
                relationship: relationship,
                parentMember: parentMember,
                subsidiaryNo: subsidiaryNo,
                planId: planId,
                gender: gender,
                emailAddress: emailAddress,
                action: 'A',
                tempId: _generateUuid()
            }
            onOk(obj);
        }
    }

    const validateDates = () => {
        let isValid = true;

        /** don't validate with employment date if relationship is not self (00) */
        if (relationship === '00') {
            if (effectiveDate.startOf('day').isBefore(employmentDate.startOf('day'))){
                setEffectiveDateErrorMessage(cfg('effectiveDateUser.errorMessages.effectiveDateLessThanEmploymentDate'));
                isValid = false;
            }

            if (employmentDate.startOf('day').isBefore(dateOfBirth.startOf('day')) ||
                employmentDate.startOf('day').isSame(dateOfBirth.startOf('day'))){
                setEmploymentDateErrorMessage(cfg('employmentDateUser.errorMessages.employmentDateLessThanDOB'));
                isValid = false;
            }
        }

        if (isValid && effectiveDate.diff(employmentDate, 'days') > 90) {
            setEffectiveDateErrorMessage(cfg('effectiveDateUser.errorMessages.effectiveDateMoreThan90'));
            isValid = false;
        }
        if (isValid && currentDate.diff(effectiveDate, 'days') > 90) {
            setEffectiveDateErrorMessage(cfg('effectiveDateUser.errorMessages.effectiveDateBackdatedMoreThan90'));
            isValid = false;
        }

        return isValid;
    }

    useEffect(() => {
        setName(null);
        setEmploymentDate(null);
        setEffectiveDate(null);
        setDateOfBirth(null);
        setSecurityId(null);
        setSubsidiaryNo(props.policy?.subsidiaryNo);
        setPlanId(props.policy?.planId);
        setRelationship('00');
        setNricErrorMessage('');
        setEffectiveDateErrorMessage('');
        setEmploymentDateErrorMessage('');
        setParentMember(null);
        setEmailAddress(null);
        setGender(null);
        setAllowAdd(props.policy?.allowAdd);

    }, [open]);

    const changeRelationship = (relationship) => {
        if (relationship === '00') {
            setParentMember('');
        }
        setRelationship(relationship);
    }

    return (
        <div>
            <Dialog open={open} onClose={onClose} className={classes.modal_box_container}>
                <DialogTitle className={classes.title}
                    title={cfg("policyDetailModals.addUser.title")}
                    onClose={onClose} lang={props.lang}
                />
                <DialogSecondaryTitle title={heading} />
                <DialogContent>
                     <div className={classes.modal_box_form_container}>
                         <div className='modal_box_form_field input_subsidiary'>
                             <FieldWrapper >
                                 <QnectSelectField
                                     formId={formId}
                                     field="subsidiary"
                                     value={subsidiaryNo}
                                     options={props.subsidiaryList}
                                     disabled={relationship !== '00' || !allowAdd}
                                     onChange={(val) => setSubsidiaryNo(val)}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_plan'>
                             <FieldWrapper >
                                 <QnectSelectField
                                     formId={formId}
                                     field="plan"
                                     value={planId}
                                     options={props.planList}
                                     disabled={relationship !== '00' || !allowAdd}
                                     onChange={(val) => setPlanId(val)}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_relationship'>
                             <FieldWrapper >
                                 <QnectSelectField
                                     formId={formId}
                                     field="relationshipUser"
                                     value={relationship}
                                     disabled={!props.policy?.allowDependent || props.policy?.allowDependent === 'N' || !allowAdd}
                                     onChange={(val) => changeRelationship(val)}
                                     errorMessage={relationshipErrorMessage}
                                 />
                             </FieldWrapper>
                         </div>
                         {
                             props.policy?.allowDependent === 'Y' && relationship && relationship !== '00' &&
                             <div className='modal_box_form_field input_relationship'>
                                 <FieldWrapper >
                                     <QnectSelectField
                                         formId={formId}
                                         field="parentMembers"
                                         value={parentMember}
                                         options={parentOptions}
                                         onChange={ val => setParentMember(val)}
                                         disabled={!allowAdd}
                                     />
                                 </FieldWrapper>
                             </div>
                         }
                         {
                             relationship === '00' &&
                             <div className='modal_box_form_field input_employmentDate'>
                                 <FieldWrapper >
                                     <QnectDateField
                                         formId={formId}
                                         field="employmentDateUser"
                                         value={employmentDate}
                                         onChange={ val => {
                                             setEmploymentDate(moment(val, 'DD/MM/YYYY'))
                                         }}
                                         errorMessage={employmentDateErrorMessage}
                                         disabled={!allowAdd}
                                     />
                                 </FieldWrapper>
                             </div>
                         }
                         <div className='modal_box_form_field input_name'>
                             <FieldWrapper >
                                 <QnectTextField
                                     formId={formId}
                                     field="nameUser"
                                     value={name}
                                     onChange={ val => {
                                         setName(val.target.value)
                                     }}
                                     disabled={!allowAdd}
                                     label={ relationship !== '00' ? cfg('genericLabels.dependentNameLabel') : null}
                                 />
                             </FieldWrapper>
                         </div>

                         <div className='modal_box_form_field input_effectiveDate'>
                             <FieldWrapper >
                                 <QnectDateField
                                     formId={formId}
                                     field="effectiveDateUser"
                                     value={effectiveDate}
                                     onChange={ val => {
                                         setEffectiveDate(moment(val, 'DD/MM/YYYY'))
                                     }}
                                     disabled={!allowAdd}
                                     errorMessage={effectiveDateErrorMessage}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_dobDate'>
                             <FieldWrapper >
                                 <QnectDateField
                                     formId={formId}
                                     field="dateOfBirthUser"
                                     value={dateOfBirth}
                                     onChange={ val => {
                                         setDateOfBirth(moment(val, 'DD/MM/YYYY'))
                                     }}
                                     disabled={!allowAdd}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_nricPassport'>
                             <FieldWrapper >
                                 <QnectTextField
                                     formId={formId}
                                     field="nricPassportUser"
                                     value={securityId}
                                     onChange={ vl => {
                                         setSecurityId(vl.target.value)
                                     }}
                                     errorMessage={nricErrorMessage}
                                     disabled={!allowAdd}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_gender'>
                             <FieldWrapper >
                                 <QnectSelectField
                                     formId={formId}
                                     field="genderUser"
                                     value={gender}
                                     onChange={(val) => setGender(val)}
                                     disabled={!allowAdd}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_email'>
                             <FieldWrapper >
                                 <QnectTextField
                                     formId={formId}
                                     field="emailAddress"
                                     value={emailAddress}
                                     onChange={(val) => setEmailAddress(val.target.value)}
                                     disabled={!allowAdd}
                                 />
                             </FieldWrapper>
                         </div>


                     </div>
                    { !allowAdd && <DialogContentText className="NonModifyMessage">
                        We regret to inform you that we are unable to proceed as changes for the next Renewal period, it must be submitted through Renewal instructions. <br/><br/>For
                        further assistance, you may contact us at <a href="mailto:acchealthupdate.sg@qbe.com">acchealthupdate.sg@qbe.com</a>.
                    </DialogContentText>
                    }
                </DialogContent>
                <DialogActions className={classes.actions}>
                    <QnectButton onClick={onClose} field="cancel" />
                    <QnectButton onClick={() => onClickOk()} field="confirm" disabled={!allowAdd}/>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default AddUserDialog;

